import classNames from 'classnames';
import { ClassNameType } from 'interfaces';

const styles = {
  component: (
    className: ClassNameType,
  ) => classNames(
    className,
    'result-row',
    'flex',
    '!mt-4',
    'justify-between',
    'text-md',
    '!border-b',
    '!pb-4',
    '!border-paleGray',
  ),
  label: classNames(
    'text-mainBlue',
  ),
  value: classNames(
    'text-mainBlue',
    'font-extrabold',
  ),
};

export default styles;
